(function() {
  'use strict';
  
  var freshbotsLoaded = false;
  var isDesktop = window.innerWidth >= 768;
  
  function loadFreshbots() {
    if (freshbotsLoaded || document.getElementById("spd-busns-spt")) {
      return;
    }
    
    freshbotsLoaded = true;
    
    (function (d, w, c) {
      if(!d.getElementById("spd-busns-spt")) {
        var n = d.getElementsByTagName("script")[0];
        var s = d.createElement("script");
        var loaded = false;
        s.id = "spd-busns-spt";
        s.async = "async";
        s.setAttribute("data-self-init", "false");
        s.setAttribute("data-init-type", "opt");
        s.src = "https://cdn.freshbots.ai/assets/share/js/freshbots.min.js";
        s.setAttribute("data-client", "a60b7a5a3a738bc62cda8ae602e93c76f7ededd8");
        s.setAttribute("data-bot-hash", "b8af6f039f0b5dc2e6581f16942523dd1efcbce1");
        s.setAttribute("data-env", "prod");
        s.setAttribute("data-region", "us");
        if (c) {
          s.onreadystatechange = s.onload = function () {
            if (!loaded) {
              c();
            }
            loaded = true;
          };
        }
        n.parentNode.insertBefore(s, n);
      }
    })(document, window, function () {
      if (window.Freshbots) {
        Freshbots.initiateWidget({
          autoInitChat: false,
          getClientParams: function () {
            return ;
          }
        }, function(successResponse) {
        }, function(errorResponse) {
        });
      }
    });
  }
  
  if (isDesktop) {
    loadFreshbots();
  } else {
    var scrollHandler = function() {
      loadFreshbots();
      window.removeEventListener('scroll', scrollHandler, { passive: true });
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
  }
})();
